<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/6.png" />
      <div class="marginLeft15">
        产品登记
      </div>
    </div>
    <div class="listController marginTop20">
      <div class="addNewBtn" @click="visible = true">
        新增登记产品
      </div>
      <div class="tabeNave marginTop20">
        <div class="title">时间选择</div>
        <el-date-picker v-model="createtime" type="date" class="marginLeft15">
        </el-date-picker>
        <div class="title marginLeft20">
          请选择审核状态
        </div>
        <el-select
          v-model="status"
          placeholder="请选择"
          clearable
          class="marginLeft20"
        >
          <el-option label="全部" :value="''"> </el-option>
          <el-option label="未提交" :value="1"> </el-option>
          <el-option label="驳回" :value="2"> </el-option>
          <el-option label="复审中" :value="3"> </el-option>
          <el-option label="初审中" :value="4"> </el-option>
          <el-option label="公示中" :value="5"> </el-option>
          <el-option label="已赋码" :value="6"> </el-option>
          <el-option label="已赋码-过期" :value="66"> </el-option>
          <!-- <el-option label="附件核对中" :value="7"> </el-option> -->
          <el-option label="待补充信息" :value="8"> </el-option>
          <el-option label="待确认信息" :value="9"> </el-option>
          <el-option label="已停用" :value="99"> </el-option>
          <!-- <el-option label="附件驳回" :value="11"> </el-option> -->
        </el-select>
        <div
          class="addNewBtn"
          style="margin-left: 20px;"
          @click="importExcelDialog"
        >
          产品批量导入
        </div>
      </div>
      <div class="marginTop20">
        <el-table
          class="tableList"
          :data="tableData"
          header-row-class-name="productListController"
        >
          <el-table-column prop="name" label="产品类型" width="180">
          </el-table-column>
          <el-table-column prop="product_name" label="产品名称" width="180">
          </el-table-column>
          <el-table-column prop="speci_model" label="规格型号">
            <template slot-scope="scope">
              <div :title="scope.row.speci_model" class="guigeController">
                {{ scope.row.speci_model }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="apply_time" label="申报日期">
          </el-table-column>

          <el-table-column prop="code_time" label="有效期"> </el-table-column>
          <el-table-column prop="quality_check_text" label="优质类型审核状态">
          </el-table-column>
          <el-table-column prop="state" label="审核状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 'hidden'" style="color:red">
                已停用
              </div>
              <div v-else>
                <div v-if="scope.row.check_status <= 4">
                  <div :title="scope.row.check_status">
                    <span
                      v-if="
                        scope.row.check_status === 1 ||
                          scope.row.check_status === 4
                      "
                      class="stateWeTijiao"
                    >
                      {{ scope.row.check_text }}
                    </span>
                    <span
                      v-else-if="scope.row.check_status === 2"
                      class="stateBohui"
                    >
                      {{ scope.row.check_text }}
                    </span>
                    <span
                      v-else-if="scope.row.check_status === 3"
                      class="stateTongguo"
                    >
                      {{ scope.row.check_text }}
                    </span>
                    <span v-else>
                      {{ scope.row.check_text }}
                    </span>
                  </div>
                </div>
                <div v-else v-html="scope.row.status_html"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="opt" label="操作" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 'hidden'" style="color:red">
                <span
                  @click="
                    $router.push({
                      query: {
                        show: 'show',
                        uuid: scope.row.uuid
                      },
                      name: 'Change'
                    })
                  "
                  class="stateWeTijiao btn"
                >
                  查看
                </span>
              </div>
              <div v-else>
                <span
                  @click="editQuality(scope.row)"
                  v-if="
                    scope.row.idstatus && scope.row.idstatus.indexOf(6) >= 0
                  "
                  class="stateWeTijiao btn"
                >
                  增加优质类型
                </span>
                <span
                  @click="expriededit(scope)"
                  v-if="scope.row.has_expried === true"
                  class="stateWeTijiao btn"
                >
                  重新提交
                </span>
                <!--不需要选择类型，就是正常的修改-->
                <span
                  @click="edit(scope)"
                  v-if="scope.row.check_status === 1"
                  class="stateWeTijiao btn"
                >
                  编辑
                </span>
                <!--需要选择类型以后再修改-->
                <span
                  v-if="scope.row.status == 'hidden'"
                  @click="enableUse(scope.row.uuid)"
                  class="stateWeTijiao btn"
                >
                  启用
                </span>
                <span
                  @click="
                    $router.push({
                      query: {
                        company_type: scope.row.agent_type,
                        savetype:
                          scope.row.agent_type === 2
                            ? 'dailishang2'
                            : 'shenchanshang',
                        uuid: scope.row.uuid
                      },
                      name: 'ProductSave'
                    })
                  "
                  v-if="scope.row.check_status === 2"
                  class="stateTongguo btn"
                >
                  修改
                </span>
                <!--下面是老的查看逻辑-->
                <span
                  @click="
                    $router.push({
                      query: {
                        onlyshow: 1,
                        uuid: scope.row.uuid
                      },
                      name: 'ProductSave'
                    })
                  "
                  v-if="
                    scope.row.check_status !== 1 && scope.row.check_status <= 4
                  "
                  class="stateWeTijiao btn"
                >
                  查看
                </span>
                <el-popconfirm
                  v-if="
                    scope.row.check_status === 1 || scope.row.check_status === 2
                  "
                  type="danger"
                  confirm-button-text="确认删除"
                  @confirm="del(scope.row.uuid)"
                  title="真的确定删除吗？"
                >
                  <span slot="reference" class="danger-red stateWeTijiao btn ">
                    删除
                  </span>
                </el-popconfirm>

                <!--新的查看界面逻辑-->
                <div v-if="parseInt(scope.row.check_status) > 4">
                  <span
                    @click="
                      $router.push({
                        query: {
                          show: 'supplement',
                          uuid: scope.row.uuid
                        },
                        name: 'Change'
                      })
                    "
                    v-if="scope.row.operat.repair"
                    class="stateTongguo btn"
                  >
                    补充信息
                    <br />
                  </span>
                  <span
                    @click="
                      $router.push({
                        query: {
                          show: 'confirm',
                          uuid: scope.row.uuid
                        },
                        name: 'Change'
                      })
                    "
                    v-if="scope.row.operat.suremsg"
                    class="stateTongguo btn"
                  >
                    确认信息
                    <br />
                  </span>
                  <span
                    @click="
                      $router.push({
                        query: {
                          show: 'reBank',
                          uuid: scope.row.uuid
                        },
                        name: 'Change'
                      })
                    "
                    v-if="scope.row.operat.annex"
                    class="stateTongguo btn"
                  >
                    重新提交附件
                    <br />
                  </span>
                  <span
                    @click="
                      $router.push({
                        query: {
                          show: 'show',
                          uuid: scope.row.uuid
                        },
                        name: 'Change'
                      })
                    "
                    class="stateWeTijiao btn"
                  >
                    查看
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="marginTop20 pageController">
          <el-pagination
            @current-change="getList"
            :total="total"
            :page-size="per_page"
            :current-page="current_page"
            background
            layout="prev, pager, next,total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--新增产品登记弹出框-->
    <el-dialog title="请选择类型" :visible.sync="visible" width="500px">
      <div class="modelTitle">我是该申报产品的</div>
      <div class="modelBtnController marginTop20">
        <div @click="jumpTuAdd(1)" class="btn">
          经销（代理）商
        </div>
        <div @click="jumpTuAdd(2)" class="btn marginLeft10">
          生产商
        </div>
      </div>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
    <!--单条记录，需要修改自身类型的时候的弹出库-->
    <el-dialog title="请选择类型" :visible.sync="changeType" width="500px">
      <div class="modelTitle">我是该申报产品的</div>
      <div class="modelBtnController marginTop20">
        <div @click="changeTypeAjax(changeUUID, 2)" class="btn">
          经销（代理）商
        </div>
        <div @click="changeTypeAjax(changeUUID, 1)" class="btn marginLeft10">
          生产商
        </div>
      </div>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
    <!--未完善企业信息-->
    <el-dialog
      :title="infoErrorShoeTitle"
      :visible.sync="infoErrorShoe"
      width="500px"
    >
      <span>
        {{ infoErrorShoeDes }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoErrorShoe = false">取 消</el-button>
        <el-button type="primary" @click="$router.push({ name: 'AgentInfo' })">
          {{ infoErrorShoeBtn }}
        </el-button>
      </span>
    </el-dialog>
    <!--未完善生产厂商信息-->
    <el-dialog
      :title="angeErrorShoeTitle"
      :visible.sync="angeErrorShoe"
      width="500px"
    >
      <span> {{ angeErrorShoeDes }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="angeErrorShoe = false">取 消</el-button>
        <el-button type="primary" @click="$router.push({ name: 'InfoList' })">
          {{ angeErrorShoeBtn }}
        </el-button>
      </span>
    </el-dialog>
    <!-- --------------------------------------弹框导入excell----------------------------------------------------------- -->
    <el-dialog
      title="导入数据"
      :visible.sync="importExcelViliable"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form :model="importForm" label-width="80px">
        <el-form-item label="上传文件">
          <span style="color: red;">只能上传xlsx,xls表格格式文件</span>
          <UpFile v-model="importForm.file" :accept="'xls,xlsx'"></UpFile>
          <a
            file-name="信息登记系统材料导入模板.xlsx"
            download="信息登记系统材料导入模板.xlsx"
            :href="apiDomain + 'assets/file/import_excel_template.xlsx'"
          >
            下载导入excel模板文件
          </a>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="goExcelInsert">提交导入</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!------------------------------------------弹框优质类型------------------------------------------------------------->
    <el-dialog
      title="增加优质类型"
      :visible.sync="qualityDialog"
      :close-on-click-modal="false"
    >
      <div class="tips" style="margin-bottom: 20px;">
        <i
          v-if="qualityForm.quality_check === 1"
          class="el-icon-circle-check"
        ></i>
        <i
          v-if="qualityForm.quality_check === 2"
          class="el-icon-circle-close"
        ></i>
        <i
          v-if="qualityForm.quality_check === 3"
          class="el-icon-warning-outline"
        ></i>
        {{ qualityForm.quality_msg }}
      </div>
      <el-form :model="qualityForm" :inline="true" class="plan-form-inline">
        <Plan class="marginTop20" title="优质类型选择">
          <el-form-item label="" class="inline head">
            <el-checkbox-group v-model="qualityForm.excelent_cate">
              <el-checkbox
                name="excelent_cate"
                v-for="excate in defaultCate"
                :class="excate.id != 2 ? 'normal' : 'hidden'"
                :label="excate.id"
                :value="excate.id"
                :key="excate.id"
                >{{ excate.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </Plan>
        <div v-for="(val, ind) in four" :key="ind">
          <Plan class="marginTop20" :title="val.name">
            <el-form-item label="填写证书编号" class="inline">
              <el-input
                :readonly="onlyshow"
                :class="onlyshow ? 'readonlit' : ''"
                v-model="four[ind].certificate_code"
                class="formInput"
              ></el-input>
            </el-form-item>
            <el-form-item label="选择规格型号" class="inline">
              <el-select
                filterable
                v-if="!onlyshow"
                v-model="four[ind].standard"
                class="formInput"
              >
                <el-option
                  class="formInput"
                  v-for="(val, ind) in speciModel"
                  :key="ind"
                  :label="val[0]"
                  :value="val[0]"
                ></el-option>
              </el-select>
              <el-input
                v-else
                :readonly="onlyshow"
                :value="four[ind].standard"
                class="formInput readonlit"
              ></el-input>
            </el-form-item>
            <div></div>
            <el-form-item label="上传证书" class="inlineTow">
              <div class="upControler">
                <Up
                  :onlyshow="onlyshow"
                  :length="1"
                  v-model="four[ind].certificate_file"
                ></Up>
                <div v-if="four[ind].certificate_file.length !== 0">
                  <div
                    v-for="(val, ind) in four[ind].certificate_file"
                    :key="ind"
                    class="upFileImgList"
                  >
                    <div class="upName">
                      <a :href="val.viewurl" target="_blank">上传的文件</a>
                    </div>
                    <i
                      @click="four[ind].certificate_file.splice(ind, 1)"
                      class="el-icon-delete del"
                      v-if="!onlyshow"
                    ></i>
                  </div>
                </div>
                <div class="des">
                  （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
                </div>
              </div>
            </el-form-item>
          </Plan>
        </div>
        <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
          <el-button @click="qualityDialog = false">关闭</el-button>
          <el-button
            v-if="qualityForm.quality_check != 3"
            type="primary"
            @click="qualitySave"
            >确 定
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/plugins/config.js";
import Api from "@/plugins/axios.js";
import Plan from "@/components/Plan.vue";
import moment from "moment";
import Up from "@/components/Up.vue";
import UpFile from "@/components/UpFile.vue";
// 从数组创造出文件列表
/**
 * 将文件数组转换为字符串
 */
function fileArrayToStr(fileArray) {
  if (fileArray !== null && fileArray !== "" && fileArray.length > 0) {
    return fileArray
      .map(function(e) {
        return e.url;
      })
      .join(",");
  } else {
    return "";
  }
}
// 从数组创造出文件列表
function buildFileArray(str) {
  if (str) {
    let arr = [];
    arr.push({
      name: "上传的文件",
      url: str,
      viewurl: Api.domain + str
    });
    return arr;
  } else {
    return [];
  }
}
export default {
  components: {
    UpFile,
    Plan,
    Up
  },
  data() {
    return {
      apiDomain: Api.domain,
      // 企业信息提交的内容
      angeErrorShoeTitle: "",
      angeErrorShoeDes: "",
      angeErrorShoeBtn: "",
      angeErrorShoe: false, // 所代理的生产厂商模态框
      infoErrorShoeTitle: "",
      infoErrorShoeDes: "",
      infoErrorShoeBtn: "",
      infoErrorShoe: false, // 企业基本信息弹出框
      agentList: [], // 生产厂商信息
      changeUUID: null, // 修改产品的时候存储的UUID
      changeType: false, // 修改产品类型的模态框
      visible: false, // 是否显示模态框
      createtime: "", // 搜索事件
      status: "", // 状态
      keyword: "", // 搜索关键词
      tableData: [], // 列表数据
      total: 0, // 总数
      per_page: 15, // 每页分页
      current_page: 1, // 当前页,
      importExcelViliable: false,
      importForm: {
        file: null
      },
      checkList: [],
      qualityDialog: false,
      qualityForm: {
        token: "",
        excelent_cate: []
      },
      detailInfo: {
        excelent_cate: []
      },
      defaultCate: [],
      onlyshow: false,
      speciModel: [],
      four: {
        greenmarks_info: {
          id: 38,
          name: "国家绿色建材评价标识编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        },
        greenauth_info: {
          id: 39,
          name: "绿色建材认证编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        },
        greenbuild_info: {
          id: 40,
          name: "云南省绿色装配式建筑“四新”与建材推广目录编入证书",
          certificate_code: "",
          standard: "",
          certificate_file: []
        }
      },
      // 编辑当前行信息
      goEditRows: {}
    };
  },
  watch: {
    createtime() {
      this.getList(1);
    },
    status() {
      this.getList(1);
    }
  },
  async mounted() {
    // 获得企业信息
    const re = await Api.userinfo(this.$store.state.token);
    this.$store.commit("SET_USERINFO", re);
    this.$store.commit("SET_USERID", re.id);
    // 获得审核通过的生产厂商信息
    const agentList = await Api.agentLi(this.$store.state.token, 2);
    // 获得提示语
    const con1 = await Api.shows(this.$store.state.token, 1);
    const con2 = await Api.shows(this.$store.state.token, 2);
    this.infoErrorShoeTitle = con1.title;
    this.infoErrorShoeDes = con1.content;
    this.infoErrorShoeBtn = con1.button;
    this.angeErrorShoeTitle = con2.title;
    this.angeErrorShoeDes = con2.content;
    this.angeErrorShoeBtn = con2.button;

    this.agentList = agentList.data;
    this.getList(1);
    this.apidomain = config.apidomain;
  },
  methods: {
    expriededit(scope) {
      // 判断企业信息审核状态
      if (parseInt(this.$store.state.userinfo.profile_step) !== 2) {
        this.changeType = false;
        this.visible = false;
        this.infoErrorShoe = true;
        return false;
      }
      // 判断是不是经销代理商
      if (scope.row.agent_type === 2 && this.agentList.length === 0) {
        this.changeType = false;
        this.visible = false;
        this.angeErrorShoe = true;
        return false;
      }
      let tempagentArr = [1, 2];
      // 针对导入的产品
      if (!tempagentArr.includes(scope.row.agent_type)) {
        //this.changeType = false;
        this.visible = true;
        this.goEditRows = scope.row;
        //this.angeErrorShoe = true;
        return false;
      }
      this.$router.push({
        query: {
          company_type: scope.row.agent_type,
          savetype:
            scope.row.agent_type === 2 ? "dailishang2" : "shenchanshang",
          uuid: scope.row.uuid,
          expired: 1
        },
        name: "ProductSave"
      });
    },
    // 编译一个产品信息
    edit(scope) {
      // 判断企业信息审核状态
      if (parseInt(this.$store.state.userinfo.profile_step) !== 2) {
        this.changeType = false;
        this.visible = false;
        this.infoErrorShoe = true;
        return false;
      }
      // 判断是不是经销代理商
      if (scope.row.agent_type === 2 && this.agentList.length === 0) {
        this.changeType = false;
        this.visible = false;
        this.angeErrorShoe = true;
        return false;
      }
      let tempagentArr = [1, 2];
      // 针对导入的产品
      if (!tempagentArr.includes(scope.row.agent_type)) {
        //this.changeType = false;
        this.visible = true;
        this.goEditRows = scope.row;
        //this.angeErrorShoe = true;
        return false;
      }

      this.$router.push({
        query: {
          company_type: scope.row.agent_type,
          savetype:
            scope.row.agent_type === 2 ? "dailishang2" : "shenchanshang",
          uuid: scope.row.uuid
        },
        name: "ProductSave"
      });
    },
    confirm() {
      this.visible = false;
      this.$emit("onConfirm");
    },
    cancel() {
      this.visible = false;
      this.$emit("onCancel");
    },
    async del(uuid) {
      try {
        await Api.infomationDelete(this.$store.state.token, uuid);
        this.getList(1);
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "删除成功"
        });
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    },
    async getList(page) {
      let createtime = null;
      if (this.createtime) {
        createtime = moment(this.createtime).format("YYYY-MM-DD");
      }
      const re = await Api.infomationIndex(
        this.$store.state.token,
        this.status,
        createtime,
        this.keyword,
        page
      );
      this.tableData = re.data.map(function(e) {
        // 规格型号的显示逻辑
        e.speci_model = e.speci_model
          .split(",")
          .map(function(e2) {
            return e2.split("^")[0];
          })
          .join(",");

        // 审核状态显示逻辑
        e.status_html = "";

        // 待补充
        let status1 = 0;
        // 待确认
        let status2 = 0;
        // 附件驳回
        let status11 = 0;
        // 公式中
        let status5 = 0;
        // 驸马
        let status6 = 0;
        // 附件核对中
        let status7 = 0;
        let status20 = 0;
        let status21 = 0;
        // 所有复审中
        let state01012 = 0;
        let stateExpired = 0;
        let nowTime = new Date().getTime() / 1000;
        console.log(nowTime, "》》》》》》》》》》》");
        if (e.check_status > 4) {
          // 循环规格型号开始判断
          e.attrs.map(function(e2) {
            switch (e2.status) {
              case 0:
                state01012++;
                break;
              case 10:
                state01012++;
                break;
              case 12:
                state01012++;
                break;
              case 2: // 后端一开始的时候弄反了 1 和 2 的状态显示（1是待确认，2 是待补充）
                status1++;
                break;
              case 1:
                status2++;
                break;
              case 5:
                status5++;
                break;
              case 6:
                if (e2.codevalidtime < nowTime) {
                  stateExpired++;
                } else {
                  status6++;
                }
                break;
              case 7:
                status7++;
                break;
              case 11:
                status11++;
                break;
              case 20:
                status20++;
                break;
              case 21:
                status21++;
                break;
              default:
                break;
            }
            return e2;
          });
          e.status_html = "";
          // 开始拼接状态字符串
          let tempStrArr = [];
          if (status1 > 0) {
            tempStrArr.push(`待补充(${status1})`);
          }
          if (status2 > 0) {
            tempStrArr.push(`待确认(${status2})`);
          }
          if (status11 > 0) {
            tempStrArr.push(`附件驳回(${status11})`);
          }
          if (status5 > 0) {
            tempStrArr.push(`公示中(${status5})`);
          }
          if (status6 > 0) {
            tempStrArr.push(`已赋码(${status6})`);
          }
          if (status7 > 0) {
            tempStrArr.push(`附件核对中(${status7})`);
          }
          if (state01012 > 0) {
            tempStrArr.push(`复审中(${state01012})`);
          }
          if (status20 > 0) {
            tempStrArr.push(`终审中(${status20})`);
          }
          if (status21 > 0) {
            tempStrArr.push(`终审驳回(${status21})`);
          }
          if (stateExpired > 0) {
            tempStrArr.push(`已赋码-过期(${stateExpired})`);
          }
          e.status_html = tempStrArr.join("<br>");
        }
        return e;
      });
      this.total = re.total;
      this.per_page = re.per_page;
      this.current_page = re.current_page;
    },
    // 修改一个产品的产品类型开始
    changeTypeStart(uuid) {
      this.changeUUID = uuid;
      this.changeType = true;
    },
    // 跳转到产品添加页
    async jumpTuAdd(type) {
      // 判断自身信息是否是完善的
      if (type !== 2) {
        Api.firstin(this.$store.state.token);
      }
      // 判断企业信息审核状态
      if (parseInt(this.$store.state.userinfo.profile_step) !== 2) {
        this.changeType = false;
        this.visible = false;
        this.infoErrorShoe = true;
        return false;
      }
      // 判断是不是经销代理商
      if (type !== 2 && this.agentList.length === 0) {
        this.changeType = false;
        this.visible = false;
        this.angeErrorShoe = true;
        return false;
      }

      if (this.goEditRows) {
        const tempRows = Object.assign({}, this.goEditRows);
        this.goEditRows = {};
        this.$router.push({
          query: {
            company_type: type,
            savetype: type !== 2 ? "dailishang2" : "shenchanshang",
            uuid: tempRows.uuid
          },
          name: "ProductSave"
        });
        return false;
      }
      this.$router.push({
        query: {
          save: "save",
          savetype: type !== 2 ? "dailishang2" : "shenchanshang"
        },
        name: "ProductSave"
      });
    },
    // 修改产品类型
    async changeTypeAjax(uuid, type) {
      // 判断自身信息是否是完善的
      if (type === 2) {
        Api.firstin(this.$store.state.token);
      }
      // 判断企业信息审核状态
      if (parseInt(this.$store.state.userinfo.profile_step) !== 2) {
        this.changeType = false;
        this.visible = false;
        this.infoErrorShoe = true;
        return false;
      }
      // 判断是不是经销代理商
      if (type === 2 && this.agentList.length === 0) {
        this.changeType = false;
        this.visible = false;
        this.angeErrorShoe = true;
        return false;
      }
      try {
        await Api.upType(this.$store.state.token, uuid, type);
        this.changeType = false;
        this.getList();
        // 页面跳转
        this.$router.push({
          query: {
            company_type: type,
            savetype: type === 2 ? "dailishang2" : "shenchanshang",
            uuid: uuid
          },
          name: "ProductSave"
        });
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    },
    //导入excel 弹框
    importExcelDialog() {
      this.importExcelViliable = true;
    },
    async goExcelInsert() {
      try {
        await Api.importInsert(this.$store.state.token, this.importForm.file);
        this.getList(this.page);
        this.importExcelViliable = false;
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "产品导入成功"
        });
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    },
    //增加优质类型
    async editQuality(row) {
      try {
        const detailinfo = await Api.infodetail(
          this.$store.state.token,
          row.uuid
        );
        const excelent_cateArr = detailinfo.excelent_cate
          ? detailinfo.excelent_cate.split(",")
          : [];
        this.qualityForm = {
          uuid: detailinfo.uuid,
          quality_check: detailinfo.quality_check,
          quality_msg: detailinfo.quality_msg,
          excelent_cate: excelent_cateArr,
          greenmarks_info: detailinfo.greenmarks_info,
          greenauth_info: detailinfo.greenauth_info,
          greenbuild_info: detailinfo.greenbuild_info
        };
        for (const key in this.four) {
          this.four[key].certificate_code = detailinfo[key]
            ? detailinfo[key].certificate_code
            : null;
          this.four[key].standard = detailinfo[key].standard;
          this.four[key].certificate_file = [];
          buildFileArray(detailinfo[key].certificate_file);
          this.qualityForm[key] = this.four[key];
        }
        var semodel = detailinfo.speci_model;
        // 产品规格型号计算
        let speci_model = semodel ? semodel.split(",") : [];
        let speci_modelR = [];
        for (let index = 0; index < speci_model.length; index++) {
          const element = speci_model[index];
          console.log(element);
          if (element.split("^").length >= 4) {
            let temp = element.split("^");
            if (temp[5]) {
              temp[5] = [
                {
                  url: temp[5]
                }
              ];
            } else {
              temp[5] = [];
            }
            // 转成数组，涉及到文件上传对话框
            speci_modelR.push(temp);
          }
        }
        this.speciModel = speci_modelR;
        this.detailInfo = detailinfo;
        this.defaultCate = detailinfo.cate_list;
        this.qualityDialog = true;
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    },
    async qualitySave() {
      try {
        // 先处理第四阶段上传的数据
        let sendparams = this.qualityForm;
        for (const key in this.four) {
          const element = this.four[key];
          sendparams[key] = {
            certificate_code: element.certificate_code, // 编号
            standard: element.standard, // 规格型号
            certificate_file: fileArrayToStr(element.certificate_file) // <a :href="val.viewurl" target="_blank">上传的文件</a>
          };
        }
        sendparams.token = this.$store.state.token;
        await Api.editQuality(sendparams);
        this.qualityDialog = false;
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "增加优质类型成功，待审核"
        });
        this.getList(1);
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    },
    async enableUse(uuid) {
      try {
        await Api.enableUse(this.$store.state.token, uuid);
        this.getList(this.page);
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "该产品启用成功，请重新提交审核"
        });
      } catch (error) {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: error
        });
      }
    }
  }
};
</script>

<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0082a4;
}

.productListController {
  color: #333333;

  th {
    background: #f0f5f7 !important;
  }
}
</style>
<style lang="less" scoped>
.listController {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 8px;
  padding: 20px 40px;

  .addNewBtn {
    cursor: pointer;
    width: 140px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 130, 164, 1);
    opacity: 1;
    border-radius: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
  }

  .tabeNave {
    display: flex;
    align-items: center;

    .title {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }

    .tab {
      cursor: pointer;
      background: #f2f2f2;
      opacity: 1;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 400;
      line-height: 23px;
      color: rgba(204, 204, 204, 1);
      opacity: 1;
      width: 60px;
      height: 23px;
      text-align: center;
    }

    .acy {
      background: rgba(0, 130, 164, 1);
      color: white;
    }
  }

  // 表格
  .tableList {
    border: 1px solid #ebeef5;
    border-bottom: 0px;

    .btn {
      cursor: pointer;
    }

    .btn:first-child {
      margin-left: 0px;
    }

    .stateWeTijiao {
      color: #666666;
    }

    .stateBohui {
      color: rgba(255, 0, 0, 1);
    }

    .stateTongguo {
      color: rgba(0, 177, 255, 1);
    }
  }

  .pageController {
    text-align: right;
  }
}

.hidden {
  display: none;
}

// 模态框
.modelTitle {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}

.modelBtnController {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn {
    text-align: center;
    width: 140px;
    height: 24px;
    line-height: 24px;
    border: 1px solid rgba(0, 130, 164, 1);
    opacity: 1;
    border-radius: 20px;
    color: rgba(0, 130, 164, 1);
    transition: all 0.2s;
    cursor: pointer;
  }

  .btn:hover {
    background: rgba(0, 130, 164, 1);
    color: white;
  }
}

// 规格型号显示div
.guigeController {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}

/deep/ .excelent-form .el-form-item__label {
  color: #0082a4;
}

.danger-red {
  color: red !important;
}
</style>
